import { createContext } from "react";
import type {
    DraggableAttributes,
    DraggableSyntheticListeners,
} from "@dnd-kit/core";
import type { BoardLock } from "./Board.types";

/** What a draggable board slot hands its `BoardCard`: the card is the handle. */
export interface BoardCardDragHandle {
    activatorRef: (node: HTMLElement | null) => void;
    /** Empty for a locked card: it isn't a drag source. */
    attributes: Partial<DraggableAttributes>;
    listeners: DraggableSyntheticListeners;
    isDragging: boolean;
    /** Keyboard drags move the card itself; it shows lifted in its slot. */
    isLifted: boolean;
    lock: BoardLock | null;
    /** Space on a locked card: the board says why it can't move. */
    onLockedPickUp: () => void;
}

export const BoardCardDragContext = createContext<BoardCardDragHandle | null>(
    null,
);
